import template from './insert-node.html';
import controller from './insert-node.controller';
import './insert-node.scss';

export default {
	template,
	controller,
	controllerAs: '$ctrl',
};
